<template>
  <div class="wrap-statistic">
    <head-view :option="title" :subtitleOpt="subtitleOpt"></head-view>
    <b-loading
      :is-full-page="true"
      :active.sync="$store.state.isLoader"
      :can-cancel="false"
    ></b-loading>
    <div class="statistics-content">
      <div class="dp-stat">
        <!-- <date-picker v-model="dateSelect" class="data-picker-custom" range lang="es" format="DD MMM YYYY" confirm @confirm="changeDate" placeholder="Todas la fechas"></date-picker> -->
        <template>
          <div>
            <div class="datepicker-trigger">
              <input
                class="input-date"
                type="text"
                id="datepicker-trigger"
                placeholder="Seleccione las fechas"
                :value="formatDates(dateOne, dateTwo)"
              />
              <AirbnbStyleDatepicker
                :trigger-element-id="'datepicker-trigger'"
                :mode="'range'"
                :fullscreen-mobile="true"
                :date-one="dateOne"
                :date-two="dateTwo"
                @date-one-selected="
                  val => {
                    dateOne = val;
                  }
                "
                @date-two-selected="
                  val => {
                    dateTwo = val;
                  }
                "
                @apply="changeDate"
              />
            </div>
          </div>
        </template>
      </div>
      <div class="content__chart" v-if="existUserChart">
        <div id="myChart" class="chart" ref="userHour"></div>
      </div>
      <div class="wrap-download">
        <button class="download-button" @click="downloadCSV">Descargar CSV</button>
      </div>
      <div class="content__table">
        <div class="wrapper-select wrapper-select--footer">
          <div class="table-section">
            <b-table
              class="table-history"
              :data="statisticsUsersTable ? statisticsUsersTable : []"
              :striped="isStriped"
              :narrowed="isNarrowed"
            >
              <template slot-scope="props">
                <b-table-column field="well" label="Elegir para comparar">
                  <b-checkbox
                    type="is-info"
                    size="is-medium"
                    :native-value="props.row"
                    v-model="users"
                  >
                  </b-checkbox>
                </b-table-column>
                <b-table-column field="id" label="Nombres" width="300">
                  {{ props.row.firstName }} {{ props.row.lastName }}
                </b-table-column>
                <b-table-column field="well" label="Correo">
                  {{ props.row.email }}
                </b-table-column>
                <b-table-column
                  field="reportedtaskstotal"
                  label="Total de tareas reportadas en puntos de control"
                  centered
                  numeric
                >
                  {{ props.row.reportedtaskstotal }}
                </b-table-column>
                <!-- <b-table-column
                  field="reportedpromtime"
                  label="Tiempo promedio"
                  centered
                  numeric
                >
                  {{ props.row.promTime }}
                </b-table-column> -->
                <b-table-column field="action" width="200">
                  <div class="table-button">
                    <a
                      @click.stop.prevent="linkToView(props.row)"
                      class="button-edit"
                      >ver histórico</a
                    >
                  </div>
                </b-table-column>
              </template>

              <template slot="empty">
                <section class="section">
                  <div class="content has-text-grey has-text-centered">
                    <p>
                      <b-icon icon="emoticon-sad" size="is-large"> </b-icon>
                    </p>
                    <p>No hay datos en el rango de fechas seleccionadas.</p>
                  </div>
                </section>
              </template>
            </b-table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import headView from "../Componentes/headView";
import { mapState } from "vuex";
import ApexCharts from "apexcharts";
import format from "date-fns/format";
export default {
  name: "Statistics",
  components: {
    headView
  },
  data() {
    return {
      title: {
        headText: "Estadísticas",
        subtitle: ""
      },
      subtitleOpt: false,
      myChart: {},
      isEmpty: true,
      isStriped: true,
      isNarrowed: true,
      isLoading: false,
      datachart: {},
      users: [],
      checkUsers: [],
      dateSelect: "",
      dateFormat: "D MMM",
      dateOne: "",
      dateTwo: ""
    };
  },
  computed: {
    ...mapState([
      "statCPs",
      "companyId",
      "statisticsUsersChart",
      "statisticsUsersChartHour",
      "statisticsUsersTable"
    ]),
    existUserChart() {
      if (this.statisticsUsersChart) {
        if (this.statisticsUsersChart.series.length != 0) {
          this.$nextTick(() => {
            this.users = [
              this.statisticsUsersTable[0],
              this.statisticsUsersTable[1],
              this.statisticsUsersTable[2]
            ];
          });
          return true;
        }
      }
      this.$store.commit("deactiveLoader");
      return false;
    },
    usersChecked() {
      this.users = [
        this.statisticsUsersTable[0],
        this.statisticsUsersTable[1],
        this.statisticsUsersTable[2]
      ];
      return this.users;
    },
    isLoadingComp() {
      if (this.statisticsUsersTable) {
        this.isLoading = false;
      }
      return true;
    }
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", "statisticsReporters");
  },
  beforeDestroy() {
    this.$store.commit("resetColorChildren", "statisticsReporters");
  },
  created() {
    this.$store.dispatch("GETSTATSUSERS", this.companyId);
  },
  watch: {
    users: function(n, o) {
      var flag = n.some(i => i == undefined);

      if (!n.length || flag) {
        return;
      } else {
        this.$store.commit("drawCompareUserStats", n);

        // this.isLoading = true
        this.$nextTick(() => {
          let userHour = new ApexCharts(
            this.$refs.userHour,
            this.statisticsUsersChartHour
          );
          userHour.render();
          this.$store.commit("deactiveLoader");
          // this.isLoading = false
        });
      }
    }
  },
  methods: {
    linkToView: function(op) {
      this.$router.push({
        name: "statisticsUserHistoric",
        params: { id: op.id }
      });
    },
    changeDate: function() {
      this.isLoading = true;
      // var obj={
      //   startDate: new Date(this.dateOne).toISOString(),
      //   endDate: new Date(this.dateTwo).toISOString()
      // }
      this.$store.dispatch("GETSTATSUSERSDATE", {
        startDate: new Date(
          new Date(this.dateOne.replace("-", ".")).setHours(0, 0, 0, 0)
        ).toISOString(),
        endDate: new Date(
          new Date(this.dateTwo.replace("-", ".")).setHours(23, 0, 0, 0)
        ).toISOString()
      });
      //usa metodo post del api con campos startDate y endDate
    },
    change: function(user) {
      if (this.users.includes(user)) {
      } else {
        this.users.push(user);
      }
    },
    formatDates(dateOne, dateTwo) {
      let formattedDates = "";
      if (dateOne) {
        formattedDates = format(dateOne, this.dateFormat);
      }
      if (dateTwo) {
        formattedDates += " - " + format(dateTwo, this.dateFormat);
      }
      return formattedDates;
    },
    downloadCSV: function() {
      const dataArray = this.statisticsUsersTable
        .map(user => {
          return {
            name: `${user.firstName} ${user.lastName}`,
            email: user.email,
            reportedtaskstotal: user.reportedtaskstotal,
            promTime: user.promTime
          };
        })
        .map(user => {
          return Object.values(user);
        });
      dataArray.unshift([
        "Nombre",
        "Correo",
        "Tareas Completadas",
        "Tiempo Promedio"
      ]);
      let csvContent =
        "data:text/csv;charset=utf-8," +
        dataArray.map(e => e.join(",")).join("\n");
      var encodedUri = encodeURI(csvContent);
      var link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "historial_de_usuarios.csv");
      document.body.appendChild(link); // Required for FF

      link.click();
    }
  }
};
</script>
<style lang="scss">
.asd__day {
  padding: 0.3em !important;
}
</style>
<style lang="scss" scoped>
.wrap-statistic {
  height: 100%;
}
.statistics-content {
  margin-top: 4em;
  padding: 2em;
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  .dp-stat {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding: 0 5rem;
  }
}
.chart {
  margin: 0 auto;
  display: flex;
  justify-content: center;
}
.table-button {
  height: 55px;
  display: flex;
  justify-content: center;
}
.button-edit {
  border: thin solid #e6e4e6;
  padding: 1rem;
  color: #000000;
  font-weight: bold;
  margin: 0;
}
.input-date {
  padding: 0.5rem 1rem;
  font-size: 0.8rem;
  border: thin solid #00a699;
}
.wrap-download {
  text-align: end;
}
.download-button {
  background-color: #00a699;
  color: #ffffff;
  padding: 8px 32px;
  border: none;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Main/StatisticsReporters.vue